export const LocalDateTime = (timeUTC) => {
  try {
    if (!timeUTC) throw new Error("Invalid input");

    const date = new Date(timeUTC);
    if (isNaN(date.getTime())) throw new Error("Invalid date");
    const timezone = Intl.DateTimeFormat("en-GB").resolvedOptions().timeZone;
    var options = {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: false,
      timeZone: timezone,
    };
    // return date.toLocaleString(options);
    return new Intl.DateTimeFormat("en-GB", options).format(date);
  } catch (error) {
    console.error("LocalDateTime error:", error);
    return "Practice session";
  }
};

export const UTCDateTime = (timeUTC) => {
  try {
    if (!timeUTC) throw new Error("Invalid input");

    const date = new Date(timeUTC);
    if (isNaN(date.getTime())) throw new Error("Invalid date");
    const options = {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: false,
      timeZone: "UTC",
    };
    return new Intl.DateTimeFormat("en-GB", options).format(date);
  } catch (error) {
    console.error("UTCDateTime error:", error);
    return "Practice session";
  }
};

export const DateTimeFormatter = (timeUTC) => {
  try {
    if (!timeUTC) throw new Error("Invalid input");

    const date = new Date(timeUTC);
    if (isNaN(date.getTime())) throw new Error("Invalid date");

    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    var options = {
      weekday: "long",
      year: "2-digit",
      month: "long",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      timeZone: timezone,
    };
    // return date.toLocaleString("en-GB", options);
    return new Intl.DateTimeFormat("en-GB", options).format(date);
  } catch (error) {
    console.error("DateTimeFormatter error:", error);
    return "Practice session";
  }
};

export const UTCDateTimeFormatter = (timeUTC) => {
  try {
    if (!timeUTC) throw new Error("Invalid input");

    const date = new Date(timeUTC);
    if (isNaN(date.getTime())) throw new Error("Invalid date");
    var options = {
      weekday: "long",
      year: "2-digit",
      month: "long",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      timeZone: "UTC",
    };
    // return date.toLocaleString("en-GB", options);
    return new Intl.DateTimeFormat("en-GB", options).format(date);
  } catch (error) {
    console.error("UTCDateTimeFormatter error:", error);
    return "Practice session";
  }
};

function padTo2Digits(num) {
  return num.toString().padStart(2, "0");
}
export const formatDate = (date) => {
  return [
    date.getFullYear(),
    padTo2Digits(date.getMonth() + 1),
    padTo2Digits(date.getDate()),
  ].join("-");
};

// --- Main function
export const timeAgo = (dateParam) => {
  if (!dateParam) {
    return "undefined";
  }

  const date = typeof dateParam === "object" ? dateParam : new Date(dateParam);
  const today = new Date();

  const years = Math.floor(
    ((today - date) % (1000 * 60 * 60 * 24 * 30 * 12 * 365)) /
      (1000 * 60 * 60 * 24 * 30 * 12)
  );
  const months = Math.floor(
    ((today - date) % (1000 * 60 * 60 * 24 * 30 * 12)) /
      (1000 * 60 * 60 * 24 * 30)
  );
  const days = Math.floor(
    ((today - date) % (1000 * 60 * 60 * 24 * 30)) / (1000 * 60 * 60 * 24)
  );

  const hours = Math.floor(
    ((today - date) % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
  );
  const minutes = Math.floor(((today - date) % (1000 * 60 * 60)) / (1000 * 60));
  const seconds = Math.floor(((today - date) % (1000 * 60)) / 1000);

  const f = ([years, months, days, hours, minutes, seconds]) => {
    return (
      (years > 0 ? `${years}Y ` : "") +
      (months > 0 ? `${months}M ` : "") +
      (days > 0 ? `${days}d ` : "") +
      (hours > 0 ? `${hours}h ` : "") +
      (minutes > 0 ? `${minutes}m ` : "") +
      `${seconds}s ago`
    );
  };
  return f([years, months, days, hours, minutes, seconds]);
};
